// extracted by mini-css-extract-plugin
export default {"tabs-content":"TabsContentStyles_tabs-content__NM7us"};